/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_StreetInputs */

const en_entity_street = /** @type {(inputs: Entity_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const de_entity_street = /** @type {(inputs: Entity_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Entity_StreetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_street = /** @type {((inputs?: Entity_StreetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_StreetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_street(inputs)
	return de_entity_street(inputs)
});